import React, { Component, useEffect, useRef, useState } from 'react'
import './App.css'
import { Link } from 'react-router-dom'
import ClipLoader from 'react-spinners/ClipLoader'
import Axios from 'axios'
import { IoIosRadioButtonOff, IoIosRadioButtonOn } from 'react-icons/io'
import validator from 'validator'
import { isPossiblePhoneNumber } from 'react-phone-number-input'
import { isValidPhoneNumber } from 'react-phone-number-input'
// import PhoneInput from "react-phone-number-input";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { API_URL } from './config'

const Partner = () => {
  const history = useHistory()
  const [business, setBusiness] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [pass1, setPass1] = useState('')
  const [pass2, setPass2] = useState('')
  const [response, setResponse] = useState('')
  const [error, setError] = useState('')
  const [errorDisplay, setErrorDisplay] = useState('none')
  const [spinning, setSpinning] = useState('none')
  const [updateDisplay, setUpdateDisplay] = useState('block')
  const [optionOne, setOptionOne] = useState('item-select-active')
  const [optionTwo, setOptionTwo] = useState('item-select')
  const [onRadioOne, setOnRadioOne] = useState(true)
  const [offRadioOne, setOffRadioOne] = useState(false)
  const [offRadioTwo, setOffRadioTwo] = useState(true)
  const [onRadioTwo, setOnRadioTwo] = useState(false)
  const [entity, setEntity] = useState('organisation')
  const [loadNotification, setLoadNotification] = useState(false)
  const [switchEntity, setSwitchEntity] = useState('')
  const [active, setActive] = useState('')
  const [instagram, setInstagram] = useState('')
  const [facebook, setFacebook] = useState('')
  const [tiktok, setTiktok] = useState('')
  const [x, setX] = useState('')
  const [linkedin, setLinkedin] = useState('')
  const [pitch, setPitch] = useState('')
  const [bio, setBio] = useState('')
  const [estdFollowers, setEstdFollowers] = useState('0')
  const [saveBtn, setSaveBtn] = useState('save-btn')
  const [disabled, setDisabled] = useState(false)
  const timeoutRef = useRef(null)

  useEffect(() => {
    document.title = 'Partner Registration'
    localStorage.setItem('entity', 'organisation')
  }, [])

  const isValid = isValidPhoneNumber(phone) // returns true if valid

  const handleBusiness = (event) => {
    setBusiness(event.target.value)
    setErrorDisplay('none')
  }

  const handleEmail = (event) => {
    setEmail(event.target.value)
    setErrorDisplay('none')
  }

  const handlePassword = (event) => {
    setPass1(event.target.value)
    setErrorDisplay('none')
  }

  const handlePassword2 = (event) => {
    setPass2(event.target.value)
    setErrorDisplay('none')
  }

  const onSubmitForm = async () => {
    setErrorDisplay('none')
    setUpdateDisplay('none')
    setSpinning('block')
    // Clear existing timeout if any
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    if (business.trim() === '') {
      setError(
        entity === 'organisation'
          ? 'Enter the name of your organization'
          : 'Enter your name and surname'
      )
      setErrorDisplay('block')
      setSpinning('none')
      setUpdateDisplay('block')
    } else if (email.trim() === '') {
      setError('Enter your email address')
      setErrorDisplay('block')
      setSpinning('none')
      setUpdateDisplay('block')
    } else if (!validator.isEmail(email)) {
      setError('Your email address is invalid')
      setErrorDisplay('block')
      setSpinning('none')
      setUpdateDisplay('block')
    } else if (phone.trim() === '') {
      setError('Enter your phone number')
      setErrorDisplay('block')
      setSpinning('none')
      setUpdateDisplay('block')
    }
    // else if (!isValid) {
    //   setError("Your phone number is invalid");
    //   setErrorDisplay("block");
    //   setSpinning("none");
    //   setUpdateDisplay("block");
    // }
    else if (
      instagram.trim() === '' &&
      facebook.trim() === '' &&
      tiktok.trim() === '' &&
      x.trim() === '' &&
      linkedin.trim() === ''
    ) {
      setError('Please provide at least one social media handle or profile URL.')
      setErrorDisplay('block')
      setSpinning('none')
      setUpdateDisplay('block')
    } else if (pitch.trim() === '') {
      setError('Tell use how you will promote Karamale')
      setErrorDisplay('block')
      setSpinning('none')
      setUpdateDisplay('block')
    } else if (bio.trim() === '') {
      setError('Add your bio or tagline')
      setErrorDisplay('block')
      setSpinning('none')
      setUpdateDisplay('block')
    } else if (pass1.length < 8) {
      setError('Password must be at least 8 characters long.')
      setErrorDisplay('block')
      setSpinning('none')
      setUpdateDisplay('block')
    } else if (pass1 !== pass2) {
      setError('Make sure both your passwords match')
      setErrorDisplay('block')
      setSpinning('none')
      setUpdateDisplay('block')
    } else {
      const baseURL = `${API_URL}/apps/kscanner/webservices.php`

      setSaveBtn('btn-disabled')
      setDisabled(true)

      const data = new FormData()
      data.append('account_name', business)
      data.append('phone', phone)
      data.append('email', email)
      data.append('password', pass1)
      data.append('accounttype', 'partner')
      data.append('platform', 'web')
      data.append('partner', 'no')
      data.append('instagram', instagram)
      data.append('facebook', facebook)
      data.append('tiktok', tiktok)
      data.append('x', x)
      data.append('linkedin', linkedin)
      data.append('partner_type', entity)
      data.append('pitch', pitch)
      data.append('bio', bio)
      data.append('follower_estimate', estdFollowers)
      data.append('query', 'VERIFYACCOUNT')

      Axios({
        method: 'POST',
        url: baseURL,
        data: data,
        withCredentials: true,
      })
        .then((response) => {
          // alert(response.data.val);

          if (response.data.status === 'success') {
            localStorage.setItem('verificationAccount', 'PARTNER')
            history.push({
              pathname: '/verification',
              state: {
                email: email,
                accounttype: 'partner',
                password: pass1,
              },
            })
          } else {
            setError(response.data.message)
            setErrorDisplay('block')
            setSpinning('none')
            setUpdateDisplay('block')
          }
          setSaveBtn('save-btn')
          setDisabled(false)
        })
        .catch((error) => {
          console.log(error)
          setSaveBtn('save-btn')
          setDisabled(false)
        })
    }

    timeoutRef.current = setTimeout(() => {
      setErrorDisplay('none')
    }, 5000)
  }

  const sms = () => {
    setOptionTwo('item-select')
    setOptionOne('item-select-active')
    setOffRadioTwo(true)
    setOnRadioTwo(false)
    setOffRadioOne(false)
    setOnRadioOne(true)
    setErrorDisplay('none')
    setActive(1)
    setEntity('organisation')
    setSwitchEntity('Switched to organizational partner')
    // If loadNotification is needed later:
    // setLoadNotification(true);
    localStorage.setItem('entity', 'organisation')

    setTimeout(() => {
      setLoadNotification(false)
    }, 3000)
  }

  const functionEmail = () => {
    setOptionOne('item-select')
    setOptionTwo('item-select-active')
    setOffRadioOne(true)
    setOnRadioOne(false)
    setOffRadioTwo(false)
    setOnRadioTwo(true)
    setErrorDisplay('none')
    setActive(1)
    setEntity('individual')
    setSwitchEntity('Switched to individual partner')
    localStorage.setItem('entity', 'individual')

    setTimeout(() => {
      setLoadNotification(false)
    }, 3000)
  }

  return (
    <div className="view">
      {/* <Header /> */}
      <div className="container">
        <div className="row justify-content-center align-content-center login-screen-containe w-100">
          <div className="col-lg-8 col-12 align-self-center pl-0 pr-0">
            <div className="log-title text-center">
              <Link to="/">
                <img src={`${API_URL}/karamale.png`} width="170" />
              </Link>
            </div>

            <div className=" BoxDashboardContainer">
              <div className="row w-100">
                <div className="col-12 text-left p-0 mb-3">
                  <span>Become an Affiliate Partner</span>
                </div>

                <div className="col-lg-6 col-sm-6 p-0 mb-3">
                  <div className={optionOne + ' w-100'} onClick={() => sms()}>
                    <div className="w-100 menu-links">
                      <div className="col-12 text-left">
                        {onRadioOne && <IoIosRadioButtonOn size={28} color={'#66b266'} />}
                        {offRadioOne && <IoIosRadioButtonOff size={28} color={'#b2b200'} />}
                        &nbsp; <span className="">Organisation</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-sm-6 p-0 mb-3">
                  <div className={optionTwo + ' w-100'} onClick={() => functionEmail()}>
                    <div className="w-100 menu-links w-100">
                      <div className="col-12 text-left">
                        {onRadioTwo && <IoIosRadioButtonOn size={28} color={'#66b266'} />}
                        {offRadioTwo && <IoIosRadioButtonOff size={28} color={'#b2b200'} />}
                        &nbsp; <span className="">Individual</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <input
                required
                type="text"
                name="business"
                placeholder={
                  entity == 'organisation' ? 'Name of your organisation' : 'Name and surname'
                }
                value={business}
                onChange={handleBusiness}
              />
              <input
                required
                type="email"
                name="email"
                placeholder="Email address"
                value={email}
                onChange={handleEmail}
              />
              <PhoneInput
                // autoFormat={false}
                disableDropdown={true}
                enableSearch={true}
                showDropdown={false}
                country={'za'}
                value={phone}
                onChange={setPhone}
                inputStyle={{
                  width: '100%',
                  background: '#f0f2f5',
                  height: '2.7em',
                }}
                containerStyle={{ marginBottom: 15 }}
                inputProps={{
                  name: 'phone',
                  required: true,
                }}
              />

              <input
                name="instagram_handle"
                placeholder="Instagram Handle"
                value={instagram}
                onChange={(e) => setInstagram(e.target.value)}
              />
              <input
                name="facebook_profile"
                placeholder="Facebook Profile URL"
                value={facebook}
                onChange={(e) => setFacebook(e.target.value)}
              />
              <input
                name="tiktok_handle"
                placeholder="TikTok Handle"
                value={tiktok}
                onChange={(e) => setTiktok(e.target.value)}
              />
              <input
                name="x_handle"
                placeholder="Twitter Handle"
                value={x}
                onChange={(e) => setX(e.target.value)}
              />
              <input
                name="linkedin_profile"
                placeholder="Linkedin profile URL"
                value={linkedin}
                onChange={(e) => setLinkedin(e.target.value)}
              />
              <label className="text-grey">
                Estimated followers: Even a rough estimate helps us understand your audience better!
              </label>
              <select onChange={(e) => setEstdFollowers(e.target.value)}>
                <option value={'less than 500'}>Less than 500</option>
                <option value={'500-2K'}>500-2K</option>
                <option value={'2K-10K'}>2K-10K</option>
                <option value={'10K+'}>10K+</option>
              </select>
              <textarea
                name="pitch"
                value={pitch}
                placeholder="How will you promote Karamale?"
                onChange={(e) => setPitch(e.target.value)}
              ></textarea>

              <textarea
                name="bio"
                value={bio}
                placeholder="A short bio or tagline. Example: I am an event curator with 10+ years in Joburg's music scene"
                onChange={(e) => setBio(e.target.value)}
              ></textarea>

              <input
                type="password"
                placeholder="Password"
                value={pass1}
                onChange={handlePassword}
              />

              <input
                required
                type="password"
                placeholder="Retype password"
                value={pass2}
                onChange={handlePassword2}
              />

              <div className="col-12 response textMedium">{response}</div>

              <button
                onClick={() => onSubmitForm()}
                className={saveBtn + ' w-100 mb-3'}
                disabled={disabled}
              >
                <span
                  style={{
                    display: updateDisplay,
                  }}
                >
                  Sign up
                </span>
                <span
                  style={{
                    display: spinning,
                  }}
                >
                  <ClipLoader
                    color={'grey'}
                    loading={true}
                    // css={override}
                    size={20}
                  />
                </span>
              </button>
              <Link to="/login" style={{ textDecoration: 'none' }}>
                <div className="text-center cancel-btn">Log in</div>
              </Link>
            </div>

            <div className="text-footer text-center pb-4">
              Become an <span>Affiliate</span> and earn up to 30% in commission.
            </div>
          </div>
        </div>
      </div>
      <div className="error-login" style={{ display: errorDisplay, textAlign: 'center' }}>
        {error}
      </div>
      {/* <Footer /> */}
      {loadNotification && (
        <div className="col-lg-3 notification-switch mb-0">
          <div className=" BoxDashboardContainer">
            <div className="col-12 text-center">
              <span>{switchEntity}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Partner
